import React, { useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

function DropdownCategories({ filterValue, setFilterValue }) {
  const filterRef = useRef(null);
  const [openFilter, setOpenFilter] = useState(false);
  const dropDownValues = [
    {
      name: "Current Month",
      value: "current_month_categorization",
    },
    {
      name: "Previous Month",
      value: "past_month_categorization",
    },
    {
      name: "Last 3 Months",
      value: "last_3_month_categorization",
    },
    {
      name: "Last 6 Months",
      value: "last_6_month_categorization",
    },
    {
      name: "Last 1 Year",
      value: "last_1_year_categorization",
    },
    {
      name: "Overall",
      value: "overall_categorization",
    },
  ];
  return (
    <div className=" relative">
      <button
        ref={filterRef}
        onClick={() => setOpenFilter(!openFilter)}
        className="  z-20 flex items-center    w-fit  text-xs focus:outline-none font-medium text-[#626262] "
      >
        {filterValue.name}
        <span>
          <IoIosArrowDown
            className=" transition-all ease-in-out duration-100 ml-1"
            style={{
              transform: openFilter ? "rotate(180deg)" : "rotate(0deg)",

              color: "#00394d",
              width: 17,
              height: 17,
            }}
          />
        </span>
      </button>
      {openFilter && (
        <div
          // ref={divRef}
          className=" w-[135px] px-[3.5px] rounded-b-lg absolute top-5 right-[2px] z-10 bg-white pt-[12px] text-xs font-medium shadow-md  pb-2 "
        >
          {dropDownValues.map((data, index) => (
            <div>
              <button
                key={index}
                onClick={() => {
                  setFilterValue(data);
                  setOpenFilter(false);
                }}
                className={` rounded w-full py-1 mt-1 px-4 ${
                  data.name !== filterValue.name && `hover:bg-[#e6ebed]`
                }  h-6 flex items-center cursor-default ${
                  data.name === filterValue.name && `bg-[#a0ff77]`
                }`}
              >
                {data.name}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DropdownCategories;
